import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { InstructionService } from '../../services/instruction.service';
import { InstructionModificationService } from '../../services/instruction-modification.service';

@Component({
    selector: 'app-intermission',
    templateUrl: './intermission.component.html',
    styleUrls: ['./intermission.component.scss'],
    standalone: false
})
export class IntermissionComponent implements OnInit {
  @Input() label: string;
  // TODO:#code fix
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onContinue = new EventEmitter<boolean>();

  content: { title: string; body: string } = {
    title: 'Good job!',
    body: '<p>Time for a little break. You can continue with the study at any time by clicking <em>Continue</em>.</p>'
  };

  constructor(
    private instructionService: InstructionService,
    private modifyInstruction: InstructionModificationService
  ) {}

  ngOnInit(): void {
    const instruction = this.instructionService.getInstructions()['intermission'];

    const body = this.modifyInstruction.replacePlaceholders(instruction['body'], '', 'intermission');

    this.content = {
      ...instruction,
      body
    };

    if (!this.label) {
      this.instructionService.getTranslationsForTerm('INTERMISSION_CONTINUE_BUTTON');
    }
  }

  continue() {
    this.onContinue.emit(true);
  }
}
